import { render, staticRenderFns } from "./CardRegistrosxRecolector.vue?vue&type=template&id=0b50a7c0&scoped=true"
import script from "./CardRegistrosxRecolector.vue?vue&type=script&lang=js"
export * from "./CardRegistrosxRecolector.vue?vue&type=script&lang=js"
import style0 from "./CardRegistrosxRecolector.vue?vue&type=style&index=0&id=0b50a7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50a7c0",
  null
  
)

export default component.exports